import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { automaticService } from "services";
import { logout } from "../logout";

export const getDevice = createAsyncThunk(
  "getDevice",
  async ({ serialNumber }, { rejectWithValue }) => {
    try {
      return await automaticService.get_device(serialNumber);
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);

const initialState = {
  currentDevice: null,
  loading: false,
  error: null,
};

const deviceSlice = createSlice({
  name: "device",
  initialState: initialState,
  reducers: {
    setCurrentDevice: (state, action) => {
      state.currentDevice = action.payload;
    },
    clearDevice: (state, _action) => {
      state.currentDevice = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDevice.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getDevice.fulfilled, (state, action) => {
      state.loading = false;
      state.currentDevice = action.payload;
      state.error = null;
    });
    builder.addCase(getDevice.rejected, (state, action) => {
      state.loading = false;
      state.currentDevice = null;
      state.error = action.payload;
    });
  },
});

export const { clearDevice, setCurrentDevice } = deviceSlice.actions;
export default deviceSlice.reducer;
